<div class="modal-header">
    <h3 class="modal-title mr-auto" translate>Data protection and privacy policy statement</h3>
</div>
<div class="modal-body">
    <p translate>We’ve Updated our Privacy Policy!</p>
    <p translate>The privacy of your personal data is very important to us. Because of this, we have updated our data protection and privacy policy. In order to continue using our platform, we kindly ask that you read and accept the new data protection and data policy terms.</p>
    <div [innerHtml]="terms"></div>
</div>
<div class="modal-footer d-flex">
    <mon-form-field-checkbox
            monId="accept_terms"
            monName="accept"
            [(model)]="accept">
    </mon-form-field-checkbox>
    <label for="accept_terms" class="form-group ml-1">{{ 'Accept Acquia Web Governance Privacy Terms' | translate }}</label>
    <button class="btn btn-primary ml-2" [disabled]="!accept || saving" (click)="submit()">
        @if(saving) {
            <span class="fas fa-spinner fa-spin fa-fw" aria-hidden="true"></span>
        } @else {
            <span >{{ 'Accept' | translate }}</span>
        }
    </button>
</div>
